import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrderData } from '@zero/shared/util-models';
import { ConfirmCancelationComponent } from '../open-orders/confirm-cancelation/confirm-cancelation.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tr[zero-cancel-open-order-item]',
  templateUrl: './cancel-open-order-item.component.html',
  imports: [ConfirmCancelationComponent],
})
export class CancelOpenOrderItemComponent {
  @Input() public order: OrderData;

  @Output() public canceled = new EventEmitter<boolean>();
}
